import * as React from "react"
import { cn, getSelectionStyles } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  hasLeftIcon?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hasLeftIcon, ...props }, ref) => {
    const [focused, setFocused] = React.useState(false)

    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm transition-colors",
          "placeholder:text-muted-foreground",
          "focus-visible:outline-none",
          hasLeftIcon && "pl-11",
          getSelectionStyles(focused),
          className
        )}
        ref={ref}
        onFocus={(e) => {
          setFocused(true)
          props.onFocus?.(e)
        }}
        onBlur={(e) => {
          setFocused(false)
          props.onBlur?.(e)
        }}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input }